module.exports = __webpack_public_path__ + "img/picto-dossier-bl.9dbec00b.svg";